var _linearGradient, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPiHole(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 380,
    viewBox: "0 0 258.30542 380.00004",
    width: 258.30542,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 7.925993107,
    x2: 204.05312733504,
    y1: 58.61002299265,
    y2: 58.61002299265
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#12b212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.924652
  }, /*#__PURE__*/React.createElement("path", {
    d: "m106.92545 116.78134c-47.437847-5.05965-95.226656-40.915875-98.9994567-116.78134 73.6134837 0 112.9792967 43.57731 116.7813467 112.62834 13.92134-82.826139 79.17032-73.116296 79.17032-73.116296 3.10013 46.94066-35.44678 75.397526-79.17032 77.766486-12.28354-25.883164-85.867778-89.377353-85.867778-89.377353a.20472562.20472562 0 0 0 -.321712.233972s71.01054 61.856384 68.4076 88.646191",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.15281 380c-4.59171-.26322-47.437854-1.90103-50.040794-50.0408-2.10575-29.24651 20.998994-50.8012 20.998994-79.19956-5.235122-70.80582-100.11082279-62.03187-100.11082279 0a58.317555 58.317555 0 0 0 17.05071979 41.35457l70.688831 70.71808a58.317555 58.317555 0 0 0 41.354572 17.05072",
    fill: "#980200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m258.30543 250.78888c-.26322 4.59171-1.90103 47.43785-50.0408 50.04079-29.24651 2.10575-50.83044-20.999-79.19956-20.999-70.805821 5.23513-62.031866 100.08159 0 100.08159a58.317555 58.317555 0 0 0 41.35457-17.05072l70.74733-70.68884a58.317555 58.317555 0 0 0 17.05072-41.35457",
    fill: "#f00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.15281 121.63626c4.5917.26322 47.43785 1.90103 50.04079 50.04079 2.10575 29.24652-20.999 50.8012-20.999 79.19957 5.23512 70.80582 100.08158 62.03187 100.08158 0a58.317555 58.317555 0 0 0 -17.05072-41.35457l-70.71808-70.74733a58.317555 58.317555 0 0 0 -41.35457-17.05072",
    fill: "#980200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.23415935 250.78888c.26321865-4.5917 1.90102365-47.43785 50.04079065-50.04079 29.246517-2.10575 50.83045 20.999 79.19957 20.999 70.80582-5.32286 62.03186-100.08158 0-100.08158a58.317555 58.317555 0 0 0 -41.354577 17.05072l-70.747325 70.71808a58.317555 58.317555 0 0 0 -17.0507191 41.35457",
    fill: "#f00"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiHole);
export default __webpack_public_path__ + "static/media/pi-hole.7d3d683221acd9f453000708176f9e41.svg";
export { ForwardRef as ReactComponent };